import React, { useMemo } from "react"
import styled from "styled-components"
import { Link, graphql, useStaticQuery } from "gatsby"
import { get } from "lodash"

import { colors } from "../../components/Color"
import Text from "../../components/New/Text/Text"

const ExternalLink = styled.a`
  color: ${colors.primary};
  &:hover {
    color: ${colors.teal};
  }

  ${Text} {
    display: inline;
    line-height: 2em;
  }
`

const NewLink = ({
  children,
  text,
  internalLink,
  externalLink,
  size = "medium",
  theme,
  state
}) => {
  const data = useStaticQuery(graphql`
    query {
      allSanityPage {
        nodes {
          _id
          slug {
            current
          }
        }
      }
    }
  `)

  const match = useMemo(
    () =>
      data.allSanityPage.nodes.find(
        ({ _id }) => get(internalLink, "_ref", "") === _id
      ),
    [data, internalLink]
  )
  const linkToInternalPage = get(match, ["slug", "current"]) || get(internalLink, "slug.current")
  return internalLink ? (
    <Link to={linkToInternalPage} state={state}>
      {children}
      {/* <Text size={size} theme={theme}>
        {text}
      </Text> */}
    </Link>
  ) : externalLink ? (
    <ExternalLink href={externalLink}>
      {children ? children : <Text size={size} theme={theme}>
        {text}
      </Text>}
    </ExternalLink>
  ) : (
    <>{children}</>
  )
}

export default NewLink
